import lightGallery from 'lightgallery';
// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgShare from 'lightgallery/plugins/share';
import lgvideo from 'lightgallery/plugins/video';

export default () => {
  apos.util.widgetPlayers.mediaGallery = {
    selector: '.mediagallery',
    player: function (el) {
      lightGallery(el, {
        selector: '.mediagallery-media',
        plugins: [ lgZoom, lgThumbnail, lgShare, lgvideo ],
        videojs: true,
        videojsOptions: {
          muted: true,
          playsinline: true,
          autoplay: true
        },
        licenseKey: '0000-0000-000-0000',
        speed: 500
        // ... other settings
      });
    }
  };
};
